export default __webpack_public_path__ + "static/media/padlock.8d2c33d2.svg";